module.exports = __webpack_public_path__ + "static/media/024.302bd939.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/024.jpg
// module id = 321
// module chunks = 0